import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-590807d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-apply-to-be" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = { class: "tip" }
const _hoisted_6 = { class: "text-center" }

import { useI18n } from 'vue-i18n';
  import { useRoute, useRouter } from 'vue-router';
  import { reactive, ref, inject } from 'vue';
  import _ from 'lodash';
  import { request } from '@/utils';
  import { ColorVariants } from '@/constants';
  import { Country, getCountryByLocale } from '@/components/country-selector/countries';
  import { IAddressAutocompleteData } from '@/components/address-autocomplete/type';
  import { IProgram } from '@/types/program';


  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const postalCode = ref();
  const { t, locale } = useI18n();
  const route = useRoute();
  const programId = route.params.id;
  const country = ref<Country>(getCountryByLocale(locale.value as any) || getCountryByLocale('ko'));

  const program = inject<IProgram>('program');

  function handleFormItemChange(data: any) {
    _.set(form, data.key, data.value);
  }

  const form = reactive({
    facility_name: '',
    postal_code: '',
    street_address: '',
    phone_number: '',
    opening_time: '',
    show_phone_on_map: ''
  });
  const router = useRouter();
  async function handleSubmit() {
    const body = {
      ...form,
      phone_number: `+${country.value.dialCode} ${form.phone_number}`
    };
    await request.post('/pdos', {
      ...body,
      program_id: programId
    });
    router.replace({ name: 'pdo.apply-to-be-form-submitted', params: { id: programId  } });
  }

  function handleGetCountry(val: Country) {
    country.value = val;
  }

  function handleGetAddress(addressInfo: IAddressAutocompleteData) {
    if (!_.isEmpty(addressInfo)) {
      const address = {
        postal_code: addressInfo.postal_code,
        street_address: [addressInfo.region, addressInfo.locality, addressInfo.street_address].filter(Boolean).join(''),
      };
      Object.assign(form, _.pickBy(address, Boolean));
    }
  }

  function handleAddressChange(data: any) {
    postalCode.value = data;
  }


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppAddressAutoComplete = _resolveComponent("AppAddressAutoComplete")!
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('title', { program: _unref(program)?.name })), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('desc')), 1)
    ]),
    _createVNode(_component_b_form, {
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AppFormGroupItem, {
          key: "facility_name",
          form: _unref(form),
          config: {
          label: _unref(t)('facility_name'),
          type: 'input',
          required: true,
          key: 'facility_name'
        },
          onChange: handleFormItemChange
        }, null, 8, ["form", "config"]),
        (_unref(locale) === 'ko')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_AppAddressAutoComplete, { onComplete: handleGetAddress }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppFormGroupItem, {
                    key: "street_address",
                    form: _unref(form),
                    config: {
              label: _unref(t)('address_1'),
              type: 'input',
              required: true,
              key: 'street_address'
            },
                    onChange: handleFormItemChange
                  }, null, 8, ["form", "config"])
                ]),
                _: 1
              }),
              _createVNode(_component_AppFormGroupItem, {
                key: "postal_code",
                form: _unref(form),
                config: {
            label: _unref(t)('postal_code'),
            type: 'input',
            required: true,
            key: 'postal_code'
          },
                onChange: handleFormItemChange
              }, null, 8, ["form", "config"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(locale) === 'ja')
                ? (_openBlock(), _createBlock(_component_AppAddressAutoComplete, {
                    key: 0,
                    "model-value": postalCode.value,
                    onComplete: handleGetAddress
                  }, null, 8, ["model-value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_AppFormGroupItem, {
                key: "postal_code",
                form: _unref(form),
                config: {
            label: _unref(t)('postal_code'),
            type: 'input',
            required: true,
            key: 'postal_code'
          },
                onChange: handleFormItemChange,
                onInput: handleAddressChange
              }, null, 8, ["form", "config"]),
              _createVNode(_component_AppFormGroupItem, {
                key: "street_address",
                form: _unref(form),
                config: {
            label: _unref(t)('address_1'),
            type: 'input',
            required: true,
            key: 'street_address'
          },
                onChange: handleFormItemChange
              }, null, 8, ["form", "config"])
            ], 64)),
        _createVNode(_component_AppFormGroupItem, {
          config: {
          label: _unref(t)('PHONE NUMBER FORM LABEL'),
          type: 'input',
          key: 'phone_number',
          inputType: 'tel',
          placeholder: country.value?.phoneFormat,
        },
          form: _unref(form),
          onChange: handleFormItemChange
        }, {
          inputBefore: _withCtx(() => [
            _createVNode(_component_AppCountrySelector, {
              "country-code": country.value?.code || _unref(locale),
              onExcountry: handleGetCountry
            }, null, 8, ["country-code"])
          ]),
          description: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('phone_number_tips')), 1)
          ]),
          _: 1
        }, 8, ["config", "form"]),
        _createVNode(_component_AppFormGroupItem, {
          key: "opening_time",
          form: _unref(form),
          config: {
          label: _unref(t)('opening_time'),
          type: 'input',
          required: true,
          key: 'opening_time'
        },
          onChange: handleFormItemChange
        }, null, 8, ["form", "config"]),
        _createVNode(_component_AppFormGroupItem, {
          key: "show_phone_on_map",
          form: _unref(form),
          config: {
          label: _unref(t)('show_phone_on_map'),
          type: 'radio',
          key: 'show_phone_on_map',
          options: [
            { value: true, text: _unref(t)('Yes') },
            { value: false, text: _unref(t)('No') },
          ]
        },
          onChange: handleFormItemChange
        }, null, 8, ["form", "config"]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('tip')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AppLoadingButton, {
            class: "btn-submit",
            pill: "",
            variant: _unref(ColorVariants).primary,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Submit')), 1)
            ]),
            _: 1
          }, 8, ["variant"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}
}

})